import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useMyCoupon(id: string) {
  const { data, status } = useQuery(queries.coupons.detail(id));
  const { pop } = useFlow();
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('쿠폰을 찾을 수 없습니다.');
      pop();
    }
  }, [data]);
  return { coupon: data, isLoading: status === 'pending' };
}

export default useMyCoupon;
